import React from "react";
import "./index.css";

export function CardLoagingSkeleton(){
  return (
    <div className="card-atendimento-skeleton">
      <div className="midia-section skeleton-animation"></div>
      <div className="info-section">
        <div className="item-section skeleton-animation"></div>
        <div className="item-section skeleton-animation"></div>
        <div className="item-section skeleton-animation"></div>
        <div className="item-section skeleton-animation"></div>
        <div className="item-section skeleton-animation"></div>
      </div>
    </div>
  )
}
